import { call, put, takeEvery } from 'typed-redux-saga';
import { PayloadAction } from '@reduxjs/toolkit';

import DashboardGateway from '~apis/dashboard';
import combinedActions from '~redux/combinedActions';

import { store } from '~redux/store';
import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';
import { ErrorMessages, SuccessMessages } from '~utils/constants';
import { TUpdateDashboarddMarketParams } from '~types/feat/dashboard';
import { toast } from 'react-toastify';

export default function* watchCloseDashboardMarket(api: DashboardGateway): SagaWatcherReturnType {
    yield takeEvery('dashboard/dashboardCloseDashboardMarketAttempt', handleCloseDashboardMarket, api);
}

function* handleCloseDashboardMarket(api: DashboardGateway, action: PayloadAction<TUpdateDashboarddMarketParams>) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const { branchCode } = action.payload;

    const response = yield* call([api, api.closeDashboardMarket], {
        authToken,
        branchCode,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.dashboardCloseDashboardMarketFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.dashboardIsMarketStatusCloseConfirmationModalOpen(false));
        toast.success(SuccessMessages.MarketStatusCloseSuccess);
        yield put(combinedActions.goldGetBranchMarketStatusAttempt({ branchCode }));
        yield put(combinedActions.dashboardCloseDashboardMarketSuccess(response.data));
    }
}
